<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="labelStatus" @change="getLabelList(true)" :disabled="loading" size="sm")
            option(value=0) {{ $t('ui.all') }}
            option(value=1) {{ $t('ui.active') }}
            option(value=-1) {{ $t('ui.inactive') }}
      .form-group.col-md-9.col-10.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getLabelList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-6.mb-1(v-if="isEditAccess")
        b-button(v-b-modal.addLabel type="button" variant="info" size="sm")
          i.fa.fa-plus
          span.ml-1 {{ $t("ui.combine.add_label") }}
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="9%")
                  span(:title="$t('ui.id')") {{ $t('ui.id') }}
                th(width="9%")
                  span(:title="$t('ui.name')") {{ $t('ui.name') }}
                th.text-center(width="6%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="10%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th(width="10%")
                  span(:title="$t('ui.created_by')") {{ $t("ui.created_by") }}
                th(width="10%")
                  span(:title="$t('ui.modified_by')") {{ $t("ui.modified_by") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
            tbody.clusterize-content
              tr(v-if="labelList.length == 0")
                td(colspan="9").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in labelList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.label_id") {{ item.label_id }}
                  span.float-right
                    a.fa.fa-list.btn.btn-ssm.btn-icon.btn-primary.ml-3(href="javascript:void(0)" @click="onGetMemberLabelList(item)" :title="$t('ui.member_list')")
                td
                  span(:title="item.label_name") {{ item.label_name }}
                td
                  div.d-flex.justify-content-center.align-items-center
                    label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changedStatus(item, $event)" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td.text-center(v-if="isEditAccess")
                  span.mr-2
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                      href="javascript:void(0)"
                      @click="onEdit(item)"
                      :title="$t('ui.edit')"
                      )
                td
                  span(:title="item.created_by") {{ item.created_by }}
                td
                  span(:title="item.modified_by") {{ item.modified_by }}
                td.text-right
                  span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}

    addlabel(@clicked="addLabel" @failed="handleFailed")
    editlabel(ref="editlabel" :item="editSelectedLabel" @clicked="afterEdit" @failed="handleFailed")
    getmemberlabellist(ref="getmemberlabellist" :item="selectedLabel" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addlabel from "@/components/member/addLabel.vue";
import editlabel from "@/components/member/editLabel.vue";
import getmemberlabellist from "@/components/member/getMemberLabelList.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addlabel,
    editlabel,
    getmemberlabellist
  },
  data: () => ({
    loading: false,
    labelList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    labelStatus: 1,
    selectedLabel: {},
    editSelectedLabel: null
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberLabel;
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_memberlabel");
    }
  },
  mounted: function() { },
  methods: {
    refresh() {
      this.getLabelList(true)
    },
    onGetMemberLabelList(e) {
      this.selectedLabel = e;
      this.$refs.getmemberlabellist.$refs.getMemberLabelList.show();
    },
    // afterGetMemberLabelList: function(item) {
    //   this.getLabelList(true);
    //   this.$helpers.showDialog(this.$t("ui.combine.edit_promo_provider_list"), this.$t("message.success"), "success");
    // },
    addLabel: function() {
      this.search = "";
      this.getLabelList(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_label"), this.$t("message.success"), "success");
    },
    onEdit(e) {
      this.editSelectedLabel = e;
      this.$refs.editlabel.$refs.editLabel.show();
    },
    afterEdit() {
      this.getLabelList(true);
      this.$helpers.showDialog(this.$t("ui.combine.edit_label"), this.$t("message.success"), "success");
    },
    getLabelList: function(isSearch) {
      let url = config.labelListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      if (this.labelStatus == 1) {
        json.label_status = true;
      } else if (this.labelStatus == -1) {
        json.label_status = false;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.labelList = response.data.dt;
                this.totalRow = this.labelList.length > 0 ? this.labelList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_label_status_confirm", { name: item.label_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.labelStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        label_id: item.label_id,
        new_status: status,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getLabelList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getLabelList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeMemberLabel", pageSize);
      this.currentPage = 1;
      this.getLabelList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLabelList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>